import React, { useContext, useState, useCallback } from "react"
import i18n from "i18n"

import SubscriptionContext from "context/subscription/subscriptionContext"
import EntitlementDialogGuard from "components/Subscription/EntitlementDialogGuard"
import { GRANTED } from "constants/entitlements"

/**
 * Hook to check entitlement permissions and show a dialog if access is denied.
 * @returns [checkEntitlement, entitlementDialog]
 * checkEntitlement(permission, title): boolean
 * entitlementDialog: JSX.Element | null
 */
export default function useEntitlementGuard() {
  const { subscriptionState } = useContext(SubscriptionContext)
  const [dialog, setDialog] = useState(null)

  const checkEntitlement = useCallback(
    (
      permission,
      title = i18n.t("entitlements.restrictedAccess"),
      content = i18n.t("entitlements.updateYourPlan"),
    ) => {
      const hasPermission =
        permission === GRANTED ||
        subscriptionState?.subscription_entitlements?.some(
          ent => ent.feature_name === permission && ent.is_enabled === true,
        )
      if (!hasPermission) {
        setDialog(
          <EntitlementDialogGuard
            title={title}
            content={content}
            onClose={() => setDialog(null)}
          />,
        )
        return false
      }
      return true
    },
    [subscriptionState],
  )

  return [checkEntitlement, dialog]
}
